var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"ui-loader-spinner",class:{
    'ui-loader-spinner--white': _vm.white,
    'ui-loader-spinner--info': !_vm.white
  },attrs:{"width":(_vm.size + "px"),"height":(_vm.size + "px"),"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}},[_c('defs'),_c('path',{attrs:{"d":"M44 25.1a18.7 18.7 0 10-37.4 0h4a14.6 14.6 0 0129.3 0h4z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }